module.exports = __webpack_public_path__ + "static/media/36_B.278927bd.png";